import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { power5 } from '../helper/easing';
import { throttle } from 'throttle-debounce';

power5();
gsap.registerPlugin(ScrollTrigger);

var tDuration = 1.5;
var tStagger = 0.2;

const linkArrow = {
	init() {		
		
		const doLinks = (obj, moveAmount) => {

			obj.forEach(arrowLink => {    		         	
	
				const tl = gsap.timeline({ paused: true });
				const t = 0.3;
				const arrow = arrowLink.querySelector('.icon-arrow-up-right')
				const arrowDown = arrowLink.querySelector('.icon-arrow-down-left')
	
				arrowLink.addEventListener('mouseenter', function () {
					throttleMouse(1);
				});
				const throttleMouse = throttle(1000, (num) => {
					return tl.play(0);
				});

				if (arrow !== null){
					tl.fromTo(arrow, t, {
						x: 0,
						y: 0,
					},
					{
						immediateRender: false,
						x: moveAmount,
						y: moveAmount*-1,
						ease: 'expo.in',
					}, 0)
					.fromTo(arrow, t, {
						x: moveAmount*-1,
						y: moveAmount,						
					},
					{
						immediateRender: false,
						x: 0,
						y: 0,
						ease: 'expo.out',
					});	
				} else if (arrowDown !== null){
					tl.fromTo(arrowDown, t, {
						x: 0,
						y: 0,
					},
					{
						immediateRender: false,
						x: moveAmount*-1,
						y: moveAmount,
						ease: 'expo.in',
					}, 0)
					.fromTo(arrowDown, t, {
						x: moveAmount,
						y: moveAmount*-1,						
					},
					{
						immediateRender: false,
						x: 0,
						y: 0,
						ease: 'expo.out',
					});						
				}
				
			});

		}
		const arrowLinks = document.querySelectorAll('.js-link-arrow-up-right');
		if (arrowLinks.length > 0) {
			doLinks(arrowLinks, 40);
		}
		const arrowBtns = document.querySelectorAll('.js-btn-icon-after-arrow-up-right');
		if (arrowBtns.length > 0) {
			doLinks(arrowBtns, 40);
		}		
		const arrowBtnDown = document.querySelectorAll('.js-btn-icon-after-arrow-down-left');
		if (arrowBtnDown.length > 0) {
			doLinks(arrowBtnDown, 40);
		}		
	},
}
const imageAni = {
	init() {

		const imageAniTriggers = document.querySelectorAll('.js-image-ani-trigger');
            
		imageAniTriggers.forEach(imageAniTrigger => {             
			var pos = "0% 66%";
			var direction = "x";

			if (imageAniTrigger.dataset.scrollposition) {
				pos = imageAniTrigger.dataset.scrollposition;
			}
			if (imageAniTrigger.dataset.imgdirection) {
				direction = imageAniTrigger.dataset.imgdirection;
			}				

			const tl = gsap.timeline({delay: 0.4});
			const img = imageAniTrigger.querySelectorAll('.js-image-ani')
		
			gsap.set(img, {'pointer-events': 'none'});

			if (direction == "x") {
				tl.set(img, {opacity: 1})
				.set(img, {'clip-path': 'polygon(0 0, 0 0, 0 100%, 0% 100%)'})
				.fromTo(img, tDuration, {
					'clip-path': 'polygon(0 0, 0 0, 0 100%, 0% 100%)',
				},
				{
					'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
					ease: 'power4.inOut',
					stagger: tStagger,
					onComplete: () => done(),
				}, 0)
				;            
			} else {
				tl.set(img, {opacity: 1})
				.set(img, {'clip-path': 'polygon(0 0, 100% 0, 100% 0, 0 0)'})
				.fromTo(img, tDuration, {
					'clip-path': 'polygon(0 0, 100% 0, 100% 0, 0 0)',
				},
				{
					'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
					ease: 'power4.inOut',
					stagger: tStagger,
					onComplete: () => done(),
				}, 0)	
			}

			function done(){
				gsap.set(img, {'pointer-events': 'auto'});
			}
		
			// Only use scrollTrigger if the section isn't already in the viewport
			if (imageAniTrigger != document.querySelector('#k-content').firstElementChild) {
				ScrollTrigger.create({
					// markers: true,
					trigger: imageAniTrigger,
					animation: tl,
					once: true,
					start: pos
				});        
			}
		
		}); 

	},
};

const doFadeAni = (targets, when) => {

	if (targets.length > 0){
		
		tDuration = 0.6;
		tStagger = 0.1;		

		targets.forEach(fadeAniTrigger => {       
			
			var pos = "0% 70%";			
			var direction = "y";			
			var moveAmount = "-30";			

			if (fadeAniTrigger.dataset.scrollposition) {
				pos = fadeAniTrigger.dataset.scrollposition;
			}
			if (fadeAniTrigger.dataset.fadedirection) {
				const d =  fadeAniTrigger.dataset.fadedirection.split(',');
				direction = d[0];
				if (d.length == 2){
					moveAmount = d[1];
				}
			}

			const tl = gsap.timeline({delay: 0.4});
			const obj = fadeAniTrigger.querySelectorAll('.js-fade-ani');
			// gsap.set(obj, {pointerEvents: 'none'});				
			
			if (direction == 'x') {
				tl
				.fromTo(obj, tDuration, {
					x: moveAmount,
					opacity: 0,
				},
				{
					x: 0,
					opacity: 1,
					ease: 'power3.out',
					stagger: {
						each: tStagger,
						// onComplete:function(){
						// 	gsap.set(this.targets()[0], {'pointer-events': 'auto'});
						// }						
					},
					// This is done as if you interact with an element before
					// the stagger finishes, pointer events isn't set on
					// the next element in the row, not sure why
					onComplete:function(){
						gsap.set(obj, {'pointer-events': 'auto'});
					},			
				}, 0)
				;            
			} else {
				tl
				.fromTo(obj, tDuration, {
					y: moveAmount,
					opacity: 0,
				},
				{
					y: 0,
					opacity: 1,
					ease: 'power3.out',
					stagger: {
						each: tStagger,
						onComplete:function(){
							gsap.set(this.targets()[0], {'pointer-events': 'auto'});
						}						
					},
					onComplete:function(){
						gsap.set(obj, {'pointer-events': 'auto'});
					},					
				}, 0)
				;   				
			}
			
			// Only use scrollTrigger if the section isn't already in the viewport
			if (when !== 'now' && fadeAniTrigger != document.querySelector('#k-content').firstElementChild) {
				ScrollTrigger.create({
					// markers: true,
					trigger: fadeAniTrigger,
					animation: tl,
					once: true,
					start: pos
				});        
			}
		
		}); 
	}
	
}

const fadeAni = {
	init() {

		const fadeAniTriggers = document.querySelectorAll('.js-fade-ani-trigger');
		doFadeAni(fadeAniTriggers);

	},
};

export {imageAni, fadeAni, doFadeAni, linkArrow};